import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReferentialService} from "../../shared/services/referential/referential.service";
import {UserService} from "../../shared/services/user/user.service";
import {User} from "../../shared/classes/user/user";
import {Level} from "../../shared/classes/level/level";
import {Subscription} from "rxjs/index";
import {StatesService} from "../../shared/services/state/states.service";
import {LevelService} from "../../shared/services/level/level.service";
import {AuthenticationService} from "../../shared/services/authentication/authentication.service";

@Component({
    selector: 'app-my-acount',
    templateUrl: './my-acount.component.html',
    styleUrls: ['./my-acount.component.css']
})
export class MyAcountComponent implements OnInit, OnDestroy {

    public update: string = "update";
    public userId: number;
    public levelId: number;
    public showSpinner: boolean;
    public typesOfRoles: any[];
    public user: User = new User();
    public level: Level = new Level();

    reloadUser: Subscription;
    reloadLevel: Subscription;

    constructor(private referentialService: ReferentialService,
                private userService: UserService,
                public statesService: StatesService,
                private levelService: LevelService,
                public authenticationService : AuthenticationService) {
        this.typesOfRoles = this.referentialService.getUserRolesForLevelAdmin();

    }

    ngOnInit() {
        this.userId = this.authenticationService.getUserId();
        this.levelId = this.authenticationService.getUserLevelId();
        this.reloadUser = this.statesService.reloadListUser
            .subscribe(() => this.getUser()
            );
        this.reloadLevel = this.statesService.reloadListLevel
            .subscribe(() => this.getLevel()
            );
        this.getUser();
        this.getLevel();
    }

    ngOnDestroy() {
        this.reloadUser.unsubscribe();
        this.reloadLevel.unsubscribe();
    }

    private getUser() {
        if (this.userId !== null) {

            this.showSpinner = true;

            this.userService.getUser(this.userId).subscribe((data: any) => {
                this.user.setUser(data);
                this.showSpinner = false;
            });
        }
    }

    private getLevel() {
        if (this.levelId !== null) {

            this.showSpinner = true;

            this.levelService.getLevel(this.levelId).subscribe((data: any) => {
                this.level.setLevel(data);
                this.showSpinner = false;

            });
        }
    }

    getRoleDisplayed(role: string) {
        let roleToDisplay: string = "";
        this.typesOfRoles.map(t => {
            if (role === t.value) roleToDisplay = t.displayedValue;
        });
        return roleToDisplay;
    }

}
